<template>
    <div id="three-step" class="scc-container three-step">
        <h4 v-if="title" class="three-step__title">{{ title }}</h4>
        <p v-if="description" class="three-step__description">{{ description }}</p>
        <div class="three-step__grid">
            <template v-for="(step, index) in steps">
                <div :key="index" class="three-step__step">
                    <img :src="step.emoji" alt="emoji" />
                    <h5 class="three-step__step-title">{{ step.title }}</h5>
                    <p class="three-step__step-description">{{ step.description }}</p>
                </div>
                <span v-if="index !== 2" :key="index + 'ico'" class="three-step__step-spacer">
                    <svg
                        class="three-step__step-icon"
                        width="11"
                        height="18"
                        viewBox="0 0 11 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M1.70697 17.707L0.292969 16.293L7.58597 8.99997L0.292969 1.70697L1.70697 0.292969L10.414 8.99997L1.70697 17.707Z"
                            fill="#424242"
                        />
                    </svg>
                </span>
            </template>
        </div>
        <SccLink v-if="showTeamlink" class="three-step__button" to="#teamlink">
            Teamlink genereren
        </SccLink>
    </div>
</template>

<script>
import './three-step-explanation.scss';

export default {
    name: 'ThreeStepExplanation',
    __editor: {
        fields: {
            title: {
                widget: 'text',
            },
            description: {
                widget: 'textarea',
            },
            emojiOne: {
                widget: 'text',
            },
            emojiTwo: {
                widget: 'text',
            },
            emojiThree: {
                widget: 'text',
            },
            titleOne: {
                widget: 'text',
            },
            titleTwo: {
                widget: 'text',
            },
            titleThree: {
                widget: 'text',
            },
            descriptionOne: {
                widget: 'text',
            },
            descriptionTwo: {
                widget: 'text',
            },
            descriptionThree: {
                widget: 'text',
            },
            showTeamlink: {
                widget: 'checkbox',
            },
        },
    },
    props: {
        title: {
            type: String,
        },
        description: {
            type: String,
        },
        emojiOne: {
            type: String,
            default: '🏷️',
        },
        emojiTwo: {
            type: String,
            default: '🏷️',
        },
        emojiThree: {
            type: String,
            default: '🏷️',
        },
        titleOne: {
            type: String,
            default: 'Step #1',
        },
        titleTwo: {
            type: String,
            default: 'Step #2',
        },
        titleThree: {
            type: String,
            default: 'Step #3',
        },
        descriptionOne: {
            type: String,
            default: 'This is a description for Step #1',
        },
        descriptionTwo: {
            type: String,
            default: 'This is a description for Step #2',
        },
        descriptionThree: {
            type: String,
            default: 'This is a description for Step #3',
        },
        showTeamlink: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        steps() {
            return [
                {
                    emoji: require('../../assets/emoji/link.svg'),
                    title: this.titleOne,
                    description: this.descriptionOne,
                },
                {
                    emoji: require('../../assets/emoji/party_face.svg'),
                    title: this.titleTwo,
                    description: this.descriptionTwo,
                },
                {
                    emoji: require('../../assets/emoji/thumbs_up.svg'),
                    title: this.titleThree,
                    description: this.descriptionThree,
                },
            ];
        },
    },
};
</script>
